import Swiper from 'swiper/core';
import { Navigation, Autoplay } from 'swiper/modules';

function initSliders() {
  const productSliders = document.querySelectorAll('.js-countries-introduction');
  if (!productSliders.length) return;

  productSliders.forEach((slider) => {
    const container = slider.closest('.js-slider-container') || document;
    const navItems = container.querySelectorAll('.c-navigation__item');
    const colors = ['green', 'blue', 'dark-green'];

    const swiper = new Swiper(slider, {
      modules: [Autoplay, Navigation],
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 16,
      watchOverflow: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 'auto' },
      },
      on: {
        init() {
          updateNavigation(this.activeIndex);
          updateContainerColor(this.activeIndex);
        },
        slideChange() {
          updateNavigation(this.activeIndex);
          updateContainerColor(this.activeIndex);
        },
      },
    });

    slider.addEventListener('mouseenter', () => {
      if (swiper.autoplay.paused !== undefined) {
        swiper.autoplay.pause();
      } else {
        swiper.autoplay.stop();
      }

      const activeProgress = container.querySelector('.c-navigation__item.is-active .is-progress');
      if (activeProgress) activeProgress.style.animationPlayState = 'paused';
    });

    slider.addEventListener('mouseleave', () => {
      if (swiper.autoplay.resume) {
        swiper.autoplay.resume();
      } else {
        swiper.autoplay.start();
      }

      const activeProgress = container.querySelector('.c-navigation__item.is-active .is-progress');
      if (activeProgress) activeProgress.style.animationPlayState = 'running';
    });

    function updateNavigation(activeIndex) {
      navItems.forEach((item, i) => {
        item.classList.remove('is-active');
        const progress = item.querySelector('.is-progress');
        if (progress) {
          progress.style.width = '0%';
          progress.classList.remove('is-animating');
        }
        if (i === activeIndex) {
          item.classList.add('is-active');
          const progressActive = item.querySelector('.is-progress');
          if (progressActive) progressActive.classList.add('is-animating');
        }
      });
    }

    function updateContainerColor(activeIndex) {
      container.classList.remove(...colors.map((c) => `is-${c}`));
      const color = colors[activeIndex % colors.length];
      container.classList.add(`is-${color}`);
    }

    navItems.forEach((item, i) => {
      item.addEventListener('click', () => {
        swiper.slideTo(i);
        swiper.autoplay.start();
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initSliders);

if (window.acf?.addAction) {
  const rerender = ($el) => initSliders($el[0] || $el);
  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
